import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Live from '../pages/live/page';
import Matches from '../pages/matches/page';
import MatchDetail from '../pages/matches/detail/page';
import NewsPage from '../pages/news/page';
import NewsDetailPage from '../pages/news/detail/page';
import Community from '../pages/community/page';
import CommunityDetail from '../pages/community/detail/page';
import About from '../pages/about/page';
import Profile from '../pages/profile/page';
import NotFound from '../pages/NotFound';
import Teams from '../pages/teams/page';
import Help from '../pages/help/page';
import Contact from '../pages/contact/page';
import Privacy from '../pages/privacy/page';
import Terms from '../pages/terms/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/live',
    element: <Live />
  },
  {
    path: '/matches',
    element: <Matches />
  },
  {
    path: '/matchesDetail/:id',
    element: <MatchDetail />
  },
  {
    path: '/news',
    element: <NewsPage />
  },
  {
    path: '/newsDetail/:id',
    element: <NewsDetailPage />
  },
  {
    path: '/teams',
    element: <Teams />
  },
  {
    path: '/community',
    element: <Community />
  },
  {
    path: '/community/:id',
    element: <CommunityDetail />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/help',
    element: <Help />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/privacy',
    element: <Privacy />
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;